export const OPEN_SUPPORTS = 'open-supports'
export const OPEN_MESURES = 'open-mesures'
export const MAP_SETEXTENT = 'map-setextent'
